import { Box } from '@mui/material';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StyledWhispersSection = styled(Box)<{ textColor: string }>`
  font-family: var(--font-family), Arial;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: ${({ textColor }) => textColor};
  justify-content: center;
  display: inline-flex;
  align-items: center;

  img {
    max-width: 25px;
    height: auto;
    flex-shrink: 0;
    @media (width < ${breakpoints.mobileL}) {
      max-width: 17px;
    }
  }

  span {
    flex-grow: 1;
    text-align: center;
  }

  @media (width < ${breakpoints.mobileL}) {
    font-size: 20px;
  }
`;
